import { Flex, Text } from "@chakra-ui/react";
import React from "react";

export type TAvsHeaderData = {
  label: string;
  value: string;
};
function AvsRibbonItem(props: TAvsHeaderData) {
  const { value, label } = props;

  return (
    <Flex direction="column" justifyContent={"center"} alignItems={"center"}>
      <Text
        fontSize="24px"
        lineHeight="28px"
        fontWeight={{ base: "600", md: "700" }}
      >
        {value}
      </Text>
      <Text fontSize="14px" lineHeight="18px" fontWeight="400">
        {label}
      </Text>
    </Flex>
  );
}

export default AvsRibbonItem;
